export enum HardwareTonerColorInfoEnum {
    MONO,
    COLOR,
    NONE,
}

